import { useRef, useEffect, useState } from "react";

const FadeInSection = ({ children, animationType }) => {
	const [isVisible, setIsVisible] = useState(false);
	const domRef = useRef();
	const animationClass = animationType ? `${animationType}-section` : "fade-up-section";

	useEffect(() => {
		const domRefCurrent = domRef.current;
		const observer = new IntersectionObserver((entries) => {
			// If the element is intersecting (visible), set isVisible to true
			// and stop observing it.
			if (entries[0].isIntersecting) {
				setIsVisible(true);
				observer.unobserve(domRefCurrent); // Stop observing after it appears once
			}
		});

		if (domRefCurrent) {
			observer.observe(domRefCurrent);
		}

		return () => {
			if (domRefCurrent) {
				observer.unobserve(domRefCurrent);
			}
		};
	}, []);

	return (
		<div className={`${animationClass} ${isVisible ? "is-visible" : ""}`} ref={domRef}>
			{children}
		</div>
	);
};

export default FadeInSection;
